import { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CartContext } from '../../contexts/CartContext';
import './CartIcon.css';

export default function CartIcon() {
    const { orders } = useContext(CartContext);
    const [isScroll, setIsSrcoll] = useState(false);
    const isLogin = localStorage.getItem('token');
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
    }, []);

    const handleScroll = () => {
        if (window.scrollY > 80) setIsSrcoll(true);
        else setIsSrcoll(false);
    };

    if (location.pathname === '/user/cart') {
        return null;
    }

    return isLogin && (
        <div 
          className={`CartIcon ${isScroll ? 'on-scroll' : ''}`}
          onClick={() => navigate('/user/cart')}
        >
            <img src="/images/partials/cart-icon.svg" alt="cart-icon" />
            <div className="amount">{orders.length}</div>
        </div>
    )
}
